import React, { useState } from "react";

import { Link } from "react-router-dom";
import { Helmet, HelmetData } from "react-helmet-async";
import { Alert, Button, Col, Container, Form, InputGroup, Row, Spinner } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { useLogin } from "../../hooks/useLogin";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { error, isPending, login } = useLogin();

  const handelSubmit = (e) => {
    e.preventDefault();
    login(email, password);
  };
  const helmetData = new HelmetData({});
  return (
    <>
      <Helmet helmetData={helmetData}>
        <title>Login</title>
      </Helmet>
      <div className="main py-4 dotted_bg">
        <Container className="my-lg-5 bg-white">
          <h4 className="text-center py-5 ff-zen fw-bold text-brown">Login</h4>
          <Row className="justify-content-center">
            <Col xs={11} lg={5} sm={6}>
              {error && (
                <Alert variant="danger" dismissible className="text-center">
                  {error && <p className="m-0">{error}</p>}
                </Alert>
              )}
              <Form onSubmit={handelSubmit}>
                <Form.Group className="mb-3 border border-primary">
                  <Form.Control
                    className="p-3 border-0"
                    type="email"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3 border border-primary rounded-0">
                  <InputGroup>
                    <Form.Control
                      className="border-0  p-3"
                      placeholder="Password"
                      type={showPassword ? "text" : "password"}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <InputGroup.Text
                      className="border-0 bg-white p-3"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={!showPassword ? faEyeSlash : faEye} />
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>

                <div className="text-center">
                  {!isPending && (
                    <Button
                      className="mb-3 w-100 p-3 rounded-pill fw-bold text-brown"
                      variant="warning"
                      type="submit"
                    >
                      Login
                    </Button>
                  )}

                  {isPending && (
                    <Button
                      className="mb-3 w-100 p-3 rounded-pill fw-bold text-brown"
                      variant="warning"
                      disabled
                    >
                      Login
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    </Button>
                  )}
                </div>
              </Form>

              <br />
              <br />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
